import { InjectionToken } from '@angular/core';
import { HashMap } from '@floori-web-components';
import { ProductExtended } from '@floori/models';
import { Observable } from 'rxjs';

export const FLOORI_FAVOURITES_PROVIDER = new InjectionToken('FLOORI_FAVOURITES_PROVIDER');

export interface FavouritesProvider {
    likedProducts$: Observable<ProductExtended[]>;
    likedProductsMap$: Observable<HashMap<ProductExtended>>;

    toggleFavouriteProduct(product: ProductExtended): void;
}
